module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 135.081 135.08",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }